import React from "react";
import { AuthContext } from "../../../lib/AuthContext";
import ParentComponent from "../../../lib/ParentComponent";
import firebase from "../../../lib/firebase";
import ar from "../../../locale";
import Loading from "../../../lib/Loading";
import { title } from "../../../constants";
import PhotoUploader from "../../../lib/PhotoUploader";

export default class ClubsPlayerAdd extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      club: {},
      club_players: {},
      loading: false,
    };
    this.matchedKey = this.props.match.params.key;
    this.clubRef = firebase.database().ref("clubs/" + this.matchedKey);
    this.clubPlayersPath = "clubs_players/" + this.matchedKey;
    this.clubPlayers = firebase.database().ref(this.clubPlayersPath);
  }

  componentDidMount() {
    super.componentDidMount();
    document.title = title + " - " + ar.add_new_player;
    this.clubRef.on("value", (snapshot) => {
      if (!snapshot.exists()) {
        this.props.history.replace("/404");
      } else {
        this.state.club = snapshot.val();
        this.updateState();
      }
    });
    this.clubPlayers.on("value", (snapshot) => {
      this.state.club_players = snapshot.val();
      this.updateState();
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.clubRef.off("value");
    this.clubPlayers.off("value");
  }

  showLoading = (show) => {
    this.state.loading = show;
    this.updateState();
  };

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  saveAvatar = async (croppedImage) => {
    this.state.croppedImage = croppedImage;
  };

  updateClubPlayerIndex = () => {
    return this.clubPlayers.child("index").transaction((index) => {
      index = index || 0;
      return ++index;
    });
  };

  /**
   * Fetch image from state and save
   */
  uploadAvatar = (key) => {
    return firebase
      .storage()
      .ref(this.clubPlayersPath + "/players/" + key)
      .put(this.state.croppedImage);
  };

  updatePlayerDetails = () => {
    let name = this.name.value;
    let number = this.number.value;
    if (this.state.croppedImage) {
      if (name && number) {
        this.showLoading(true);
        let clubPlayersKey = this.messageIdGenerator();
        this.clubPlayers
          .child("players/" + clubPlayersKey)
          .set({
            uid: clubPlayersKey,
            name: name,
            number: number,
            index: (this.state.club_players.index || 0) + 1,
          })
          .then(() => this.updateClubPlayerIndex())
          .then(() => this.uploadAvatar(clubPlayersKey))
          .then((snapshot) => snapshot.ref.getDownloadURL())
          .then((downloadURL) =>
            this.clubPlayers
              .child("players/" + clubPlayersKey)
              .update({ avatar: downloadURL })
          )
          .then(() => {
            this.showLoading(false);
            this.showSuccess(ar.operation_successful);
            this.props.history.replace("/clubs/" + this.matchedKey);
          })
          .catch((error) => {
            this.showLoading(false);
            this.showError(error.message);
          });
      } else {
        this.showError(ar.enter_valid_details);
      }
    } else {
      this.showError(ar.edit_profile_pic);
    }
  };

  /**
   * Generates a new message id for the firebase chat
   */
  messageIdGenerator = () => {
    return this.clubPlayers.child("players/").push().key;
  };

  render() {
    let { club, loading } = this.state;
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card no-toolbar border-0">
                <div className="card-body d-flex flex-row">
                  <div className="">
                    <img
                      src={club.avatar}
                      className="avatarc ml-2 mr-2"
                      height="60"
                      width="60"
                      alt="avatar"
                    />
                  </div>
                  <div className="flex1">
                    <h2 className="card-title">{club.name}</h2>
                    <h5 className="card-subtitle mb-0">{ar.add_new_player}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <div className="form-group">
                    <label
                      htmlFor="inputname"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.name}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.name = e)}
                      className="form-control"
                      id="inputname"
                      placeholder={ar.enter_name}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="numberf"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.number}
                    </label>
                    <input
                      type="number"
                      ref={(e) => (this.number = e)}
                      className="form-control"
                      id="numberf"
                      placeholder={ar.number}
                    />
                  </div>
                  <div className="button-group mt-3">
                    <button
                      type="button"
                      className="btn waves-effect waves-light btn-rounded btn-info min-w100"
                      onClick={this.updatePlayerDetails}
                    >
                      {ar.save}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <PhotoUploader
                onSaveAvatar={this.saveAvatar}
                cropwidth={120}
                cropheight={120}
              />
            </div>
          </div>
        </div>
        <Loading show={loading} />
      </div>
    );
  }
}
